'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Col, Row, Container, ListGroup } from 'reactstrap';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import JobTeaser from 'shared/components/JobTeaser';
import AgencyTeaser from 'shared/components/AgencyTeaser';
import IndexJobSearchForm from 'shared/components/IndexJobSearchForm';
import Pager from 'shared/components/Pager';
import Loading from 'shared/components/Loading';
import mapMarkerIcon from 'shared/icons/mapmarker.svg';
import mapMarkerSandYou from 'shared/icons/mapmarker-sandyou.svg';
import AgencyNotFound from 'shared/components/svg/AgencyNotFound';
import { useRouter } from 'next/navigation';
import { Agency } from 'shared/pages/Agencies';
import { Locale, SynergiejobsDictionary } from 'shared/i18n/i18n-config';

type Props = {
  jobData: { jobs: Job[]; count: number };
  page: number;
  agency: Agency;
  dictionary: SynergiejobsDictionary;
  locale: Locale;
};
function AgencyDetails({ jobData, page, agency, dictionary, locale }: Props) {
  const { push } = useRouter();
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyBupFH0E8sisWkj87o6MEYxFRueNVm9RuY',
    libraries: ['places'],
  });
  const { lat, lng, apps } = agency;
  const center = { lat, lng };
  const changePage = async (newPage: number) => {
    const query = { page: String(newPage) };
    const queryString = new URLSearchParams(query).toString();
    push(`?${queryString}`);
  };
  const isSandYou = apps?.includes('sandyou.be');

  if (!agency) return <AgencyNotFound />;

  return (
    <Container>
      <Row className="mb-3">
        <Col xs={12} lg={6} className="mapsContainer">
          {isLoaded ? (
            <div className="embed-responsive embed-responsive-16by9 h-100" style={{ paddingBottom: '32px' }}>
              <GoogleMap mapContainerClassName="embed-responsive-item h-100" center={center} zoom={15}>
                <Marker
                  position={center}
                  icon={{ url: (isSandYou ? mapMarkerSandYou : mapMarkerIcon).src, scaledSize: new google.maps.Size(70, 70) }}
                />
              </GoogleMap>
            </div>
          ) : (
            <Loading />
          )}
        </Col>
        <Col xs={12} xl={6}>
          <AgencyTeaser locale={locale} dictionary={dictionary} detail agency={agency} openingTimes prependBrandName />
        </Col>
      </Row>
      <Row>
        <Col xs={12} xl={8}>
          {jobData && jobData.jobs && (
            <>
              <ListGroup>
                {jobData.jobs.map((job: Job) => (
                  <JobTeaser dictionary={dictionary} key={job.id} job={job} />
                ))}
              </ListGroup>
              <Pager
                className="mt-3"
                currentPage={page}
                totalPages={jobData ? Math.ceil(jobData.count / 10) : 0}
                changePage={changePage}
              />
            </>
          )}
        </Col>
        <Col xs={12} xl={4}>
          <IndexJobSearchForm dictionary={dictionary} id="side" withHeader />
        </Col>
      </Row>
    </Container>
  );
}

export default AgencyDetails;
